/**
 * Textos da tela "Correção privada do rascunho" (E160.F3, GUS-145, ADR-0110 §2.4). O pedido, a
 * prévia, o texto dos trechos e o limite vêm do servidor; aqui ficam os rótulos, as situações e as
 * recusas. Nada desta tela vai ao cliente.
 */
export const ptBRCorrecao = {
  sobretitulo: 'Trabalho / Equipe',
  titulo: 'Correção privada do rascunho',
  subtitulo:
    'O que a análise leu errado ou deixou de ler se corrige na fonte, e a análise roda de novo. A redação se corrige nos trechos do laudo. Nada aqui é enviado ao cliente.',
  voltar: 'Voltar ao laudo',
  linkParaAConferencia: 'Conferir laudo e orientações',
  linkParaACorrecao: 'Correção privada do rascunho',
  linkParaALeitura: 'Rever leitura na fonte',
  carregando: 'Carregando…',
  tentarDeNovo: 'Tentar de novo',
  rodadaVigente: 'Rodada vigente: {rodada}.',
  semCorrecao: {
    grafotecnica:
      'A correção privada é do exame eletrônico. O laudo grafotécnico segue a edição da revisão do perito.',
    sem_resultado: 'O caso ainda não tem resultado avaliado para corrigir.',
    sem_ficha: 'O caso ainda não tem a leitura dos documentos gravada.',
    nao_aplicavel: 'O relatório de risco só existe no exame em modo PARTE.',
    indisponivel:
      'Esta saída ainda não pode ser montada: a análise ou a busca dos riscos não estão prontas.',
    sem_perfil_normativo:
      'Esta saída ainda não pode ser montada: falta o perfil normativo da operação. A mesa diz o que falta e onde informar.',
  },
  pedido: {
    titulo: 'Pedir correção',
    rotulo: 'O que está errado ou faltou?',
    ajuda:
      'Ex.: "faltou o RG, mas está no documento". O pedido vira uma proposta para rever um dado na fonte ou levar à mesa; nenhum texto entra no laudo por aqui.',
    enviar: 'Pedir proposta',
    enviando: 'Preparando a proposta…',
    curto: 'Escreva ao menos {minimo} caracteres.',
    falhou: 'Os trechos do laudo abaixo continuam editáveis.',
  },
  propostas: {
    titulo: 'Propostas',
    nenhuma: 'Nenhum pedido feito nesta versão.',
    pedidoRotulo: 'Pedido',
    criadaEm: 'Pedida em {quando}, rodada {rodada}.',
    aplicar: 'Aplicar',
    levarAMesa: 'Levar à mesa',
    descartar: 'Descartar',
    abrirAMesa: 'Abrir a mesa',
    aplicando: 'Aplicando…',
    aplicadaAjuda: 'A leitura foi revista na fonte e a análise rodou de novo.',
  },
  tipo: {
    campo: 'Rever na fonte: {campo}',
    documento: 'Rever o documento na fonte',
    mesa: 'É de mérito, conclusão ou limite: segue para a revisão na mesa.',
    sem_proposta: 'O pedido não aponta um dado da fonte. A redação se corrige nos trechos abaixo.',
  },
  situacao: {
    aberta: 'Aberta',
    desatualizada: 'Desatualizada',
    aplicada: 'Aplicada',
    encaminhada: 'Levada à mesa',
    descartada: 'Descartada',
  },
  situacaoAjuda: {
    desatualizada:
      'A leitura ou a análise mudou depois desta proposta. Peça de novo se ainda for preciso.',
  },
  previa: {
    titulo: 'O que a fonte diz',
    campo: 'Campo',
    hoje: 'Hoje',
    naFonte: 'Na fonte',
    onde: 'Onde',
    vazio: 'sem valor',
    pagina: '{documento}, página {pagina}',
    semPagina: '{documento}',
    candidatas: '{n} valores diferentes no papel',
  },
  resultado: {
    mudou: 'Muda o valor',
    sem_mudanca: 'Confirma o valor',
    ambigua: 'Ambígua',
    nao_localizado: 'Não localizado',
  },
  trechos: {
    titulo: 'Trechos do laudo',
    ajuda: 'Edite só a redação. Toda edição exige fundamento e fica no histórico do caso.',
    noLaudo: 'No laudo',
    naoSai: 'Não sai no laudo.',
    original: 'Texto original',
    semNota: 'Sem nota nesta seção.',
    editadoEm: 'Editado na rodada {rodada}: {fundamento}',
    textoRotulo: 'Texto',
    fundamentoRotulo: 'Fundamento',
    fundamentoAjuda: 'Por que muda (ao menos {minimo} caracteres). Fica no histórico do caso.',
    editar: 'Editar',
    escrever: 'Escrever a nota',
    fechar: 'Fechar',
    salvando: 'Salvando…',
    assinado: 'O laudo desta versão já foi assinado: a edição não entra mais nele.',
  },
  acao: {
    substituir: 'Salvar o texto',
    remover: 'Tirar do laudo',
    restaurar: 'Voltar ao original',
    escrever: 'Salvar a nota',
  },
  acaoDaNota: {
    remover: 'Tirar a nota',
  },
  desatualizadas: {
    titulo: 'Edições de uma versão anterior',
    // E184.F1 (ADR-0136 §1): a edição que ainda se aplica segue sozinha; aqui ficam as do trecho
    // cujo texto original mudou.
    ajuda:
      'A análise mudou e o texto original destes trechos também, então a edição não entrou no documento. Escreva de novo no trecho atual o que ainda valer.',
    reaplicar: 'Reaplicar',
    fundamento: 'Fundamento: {fundamento}',
    trechoMudou: 'O texto original deste trecho mudou: escreva a edição de novo.',
    trechoAnterior: 'Trecho de uma versão anterior',
  },
  erro: {
    sem_permissao: 'Só a equipe do exame corrige o rascunho.',
    nao_encontrado: 'Caso, proposta ou edição não encontrados.',
    sem_resultado: 'O caso ainda não tem resultado avaliado para corrigir.',
    sem_ficha: 'O caso ainda não tem a leitura dos documentos gravada.',
    sem_protocolo:
      'O caso não tem protocolo informado. Informe o protocolo antes de rever a leitura.',
    fora_do_eletronico: 'A correção privada é do exame eletrônico.',
    proposta_desatualizada:
      'A leitura ou a análise mudou depois desta proposta. Peça de novo se ainda for preciso.',
    proposta_decidida: 'Esta proposta já foi decidida.',
    sem_acao: 'Esta proposta não aponta nada a aplicar.',
    pedido_sem_chave:
      'O pedido não pôde ser preparado: o serviço não está configurado para este escritório.',
    pedido_tempo: 'O pedido demorou demais e não foi preparado. Tente de novo.',
    pedido_indisponivel: 'O pedido não pôde ser preparado agora. Tente de novo.',
    releitura_esgotada:
      'Este campo já foi relido o número máximo de vezes. Corrija o valor com fonte em "Rever leitura de um campo", na leitura dos documentos.',
    releitura_recusada:
      'Este dado não se revê por esta proposta. Confira em "Rever leitura de um campo", na leitura dos documentos.',
    verificacao_indisponivel: 'A análise não pôde ser refeita agora. Atualize a página.',
    peca_certificada:
      'Uma peça já teve a certificação requerida: a mudança pede o caminho da reemissão.',
    outra_rodada: 'A análise mudou enquanto você editava. Recarregue e edite de novo.',
    outra_edicao: 'Outra edição deste trecho entrou antes da sua. Recarregue e edite de novo.',
    assinado: 'O laudo desta versão já foi assinado: a edição não entra mais nele.',
    trecho_mudou: 'O texto original deste trecho mudou: escreva a edição de novo.',
    ja_vigente: 'Esta edição já vale para esta versão.',
    saida_indisponivel:
      'Esta saída não pode ser editada agora: ela ainda não se monta para este caso.',
    texto_longo:
      'O texto passou do tamanho que este campo do risco aceita. Encurte e salve de novo.',
    indisponivel: 'Não foi possível concluir. Tente novamente.',
  },
};
